import {css} from '../../theme/css'
import {spacing} from '../../theme/theme'
import {ClassNameMap, makeStyles} from '../../theme/UNSTABLE_makeStyles'
import {ChipSize, ColorClassName} from './types'

const root = css`
  display: inline-flex;
  height: ${spacing(3)};
  padding: ${spacing(0, 1)};
  border-radius: ${spacing(1.5)};
  flex-wrap: nowrap;
  white-space: nowrap;
`
export const sizeClasses: Record<ChipSize, string> = {
  m: css``,
  l: css`
    height: ${spacing(4)};
    padding: ${spacing(0, 1.5)};
    border-radius: ${spacing(2)};
  `,
}

const colorClasses: ClassNameMap<ColorClassName> = {
  color_cyan: css`
    color: #80d8f8;
    background-color: rgba(128, 216, 248, 0.2);
  `,
  color_yellow: css`
    color: #fac220;
    background-color: rgba(250, 194, 32, 0.2);
  `,
  color_blue: css`
    color: #0596fa;
    background-color: rgba(5, 150, 250, 0.2);
  `,
  color_green: css`
    color: #1cc052;
    background-color: rgba(28, 192, 82, 0.2);
  `,
  color_red: css`
    color: #fa3e2c;
    background-color: rgba(250, 62, 44, 0.2);
  `,
  color_orange: css`
    color: #fa6a3c;
    background-color: rgba(250, 106, 60, 0.2);
  `,
  color_orange_light: css`
    color: #e98918;
    background-color: rgba(233, 137, 24, 0.2);
  `,
  color_gray: css`
    color: #8a8784;
    background-color: rgba(138, 135, 132, 0.2);
  `,
}
const classes = Object.assign({root}, colorClasses)

export type ClassKey = keyof typeof classes

export const useClasses = makeStyles(classes)
